import type { Opportunity } from "~/lib/api";

type Props = {
  opportunity: Opportunity;
  onOpen: (id: string) => void;
};

const TYPE_LABELS: Record<string, string> = {
  job: "Job",
  gig: "Gig",
  mentorship: "Mentorship",
  collab: "Collab",
  speaking: "Speaking",
};

export function PostedOpportunityCard(props: Props) {
  return (
    <button
      type="button"
      class="intel-block-card intel-block-card--accent"
      onClick={() => props.onOpen(props.opportunity.id)}
    >
      <span class="status-chip">{TYPE_LABELS[props.opportunity.type] ?? props.opportunity.type}</span>
      <strong>{props.opportunity.title}</strong>
    </button>
  );
}
